import styled from "styled-components";
import { styles } from "assets/style/global";

export const InputStyled = styled.input`
    border: 1px solid #c3c3c3;
    border-radius: 48px;
    height: 48px;
    width: 80%;
    color: ${styles.color.secondary};
    background-color: #f4f4f4;
    outline: none;
    font-size: .8rem;
    padding: 0 24px;
`